import { ChangeDetectionStrategy, Component, ElementRef } from '@angular/core';

@Component({
  selector: 'rt-sparks-animation',
  templateUrl: './sparks-animation.component.html',
  styleUrls: ['./sparks-animation.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class SparksAnimationComponent {
  constructor(public elRef: ElementRef) {}
}
